import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { SharingSchedulesSettings } from "../../sharing.types";
import { requestSharingSchedulesSettings } from "./sharingSchedulesSettings.request";

const useSharingsSchedulesSettings = (
  options?: QueryOptions<SharingSchedulesSettings, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["sharing-schedules-settings"],
    queryFn: requestSharingSchedulesSettings,
    ...options
  });

  return {
    mode: data?.mode,
    logo: data?.logo,
    background: data?.background,
    ...rest
  };
};

export default useSharingsSchedulesSettings;
